import { CALL_API } from "redux-api-middleware";
import { ho } from "apis/homeowner/ho";
import { broker_API } from "apis/broker";
import {
  REQUEST_BROKERCASEHEADER, RECEIVE_BROKERCASEHEADER, ERROR_BROKERCASEHEADER,
  REQUEST_BROKERHISTORY, RECEIVE_BROKERHISTORY, ERROR_BROKERHISTORY,
  REQUEST_BROKERWAIVER_DECISION, RECEIVE_BROKERWAIVER_DECISION, ERROR_BROKERWAIVER_DECISION,
  REQUEST_BROKERWAIVER_DECISION_POST, RECEIVE_BROKERWAIVER_DECISION_POST, ERROR_BROKERWAIVER_DECISION_POST,
  REQUEST_USER_REGISTRATION,
  RECEIVE_USER_REGISTRATION,
  ERROR_USER_REGISTRATION,

  REQUEST_AVAILABLE_COMPANIES,
  RECEIVE_AVAILABLE_COMPANIES,
  ERROR_AVAILABLE_COMPANIES,

  REQUEST_BROKER_SETTINGS,
  RECEIVE_BROKER_SETTINGS,
  ERROR_BROKER_SETTINGS,

  SAVE_BROKER_COMPANIES,
  RECEIVE_BROKER_SAVE_COMPANIES,
  ERROR_BROKER_SAVE_COMPANIES,

  SAVE_BROKER_CORRESPONDENT,
  RECEIVE_BROKER_SAVE_CORRESPONDENT,
  ERROR_BROKER_SAVE_CORRESPONDENT


} from "typeConstants";
import responseHandler from "responseHandler";
import { userLogout } from "actions/user";
import { push } from "react-router-redux";

const userRegistration = (user) => {
  return (dispatch) => (
    dispatch({
      [CALL_API]: {
        endpoint: broker_API.register(),
        method: "POST",
        body: JSON.stringify(user),
        types: [
          REQUEST_USER_REGISTRATION,
          {
            type: RECEIVE_USER_REGISTRATION,
            payload: (action, state, res) =>
              res.json()
                .then((data) => data)
          },
          {
            type: ERROR_USER_REGISTRATION,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};


const saveBrokerCorrespondent = (brokerSet) => {
  return (dispatch) => (
    dispatch({
      [CALL_API]: {
        endpoint: broker_API.saveBrokerCorrespondent(),
        method: "POST",
        body: JSON.stringify(brokerSet),
        types: [
          SAVE_BROKER_CORRESPONDENT,
          {
            type: RECEIVE_BROKER_SAVE_CORRESPONDENT,
            payload: (action, state, res) =>
              res.json()
                .then((data) => data)
          },
          {
            type: ERROR_BROKER_SAVE_CORRESPONDENT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const saveBrokerCompanies = (brokerSet) => {
  return (dispatch) => (
    dispatch({
      [CALL_API]: {
        endpoint: broker_API.saveBrokerCompanies(),
        method: "POST",
        body: JSON.stringify(brokerSet),
        types: [
          SAVE_BROKER_COMPANIES,
          {
            type: RECEIVE_BROKER_SAVE_COMPANIES,
            payload: (action, state, res) =>

              res.json()
                .then((data) => {
                  dispatch(push("/login"));
                  dispatch(userLogout());
                  setTimeout(() => {
                    responseHandler.success(data.message, dispatch);
                  }, 0);
                })
          },
          {
            type: ERROR_BROKER_SAVE_COMPANIES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const getAvailableCompanies = () => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: broker_API.getAvailableCompanies(),
        method: "GET",
        types: [
          REQUEST_AVAILABLE_COMPANIES,
          {
            type: RECEIVE_AVAILABLE_COMPANIES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_AVAILABLE_COMPANIES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getBrokerSettings = () => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: broker_API.getBrokerSettings(),
        method: "GET",
        types: [
          REQUEST_BROKER_SETTINGS,
          {
            type: RECEIVE_BROKER_SETTINGS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_BROKER_SETTINGS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};


const getBrokerCaseHeader = (id) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: ho.getBrokerCaseHeader(id),
        method: "GET",
        types: [
          REQUEST_BROKERCASEHEADER,
          {
            type: RECEIVE_BROKERCASEHEADER,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKERCASEHEADER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};


const getBrokerHistory = (id) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: ho.getBrokerHistory(id),
        method: "GET",
        types: [
          REQUEST_BROKERHISTORY,
          {
            type: RECEIVE_BROKERHISTORY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKERHISTORY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getWaiverDetails = (id) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: ho.getBrokerWaiver(id),
        method: "GET",
        types: [
          REQUEST_BROKERWAIVER_DECISION,
          {
            type: RECEIVE_BROKERWAIVER_DECISION,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKERWAIVER_DECISION,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const saveWaiverDecision = (waiverDecision) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: ho.postWaiverDecision(),
        method: "POST",
        body: JSON.stringify(waiverDecision),
        types: [
          REQUEST_BROKERWAIVER_DECISION_POST,
          {
            type: RECEIVE_BROKERWAIVER_DECISION_POST,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  responseHandler.success(data.errorMessage, dispatch);
                  data.handled = true;
                  return data;
                })
          }, {
            type: ERROR_BROKERWAIVER_DECISION_POST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

export {
  getBrokerCaseHeader,
  getBrokerHistory,
  getWaiverDetails,
  saveWaiverDecision,
  getAvailableCompanies,
  getBrokerSettings,
  saveBrokerCorrespondent,
  saveBrokerCompanies,
  userRegistration
};